import { Heading, Stack, VStack } from "@chakra-ui/react";

import { ConnectWalletButton } from "./connect-wallet-button";

import { useAuth } from "@/hooks/useAuth";

export const ReferralBanner = () => {
  const { isAuthenticated, referrerFromUrl } = useAuth();
  if (isAuthenticated || !referrerFromUrl) return null;

  return (
    <Stack
      direction={["column", "row"]}
      gap={4}
      w="full"
      justifyContent={["flex-start", "space-between"]}
      alignItems="center"
      rounded="24px"
      bg="bg.inverted"
      p={8}
      color="fg.inverted"
    >
      <VStack gap={0.5} alignItems="flex-start">
        <Heading size="xl" fontWeight="500" lineHeight="28px">
          You have been invited!
        </Heading>
        <Heading
          size="lg"
          color="rgba(255, 255, 255, 0.60)"
          fontWeight="500"
          lineHeight="24px"
        >
          {`${referrerFromUrl} has invited you to join the Plume Hub`}
        </Heading>
      </VStack>
      <ConnectWalletButton inverted />
    </Stack>
  );
};
